import { gql } from "@apollo/client";

export const lineItemFragment = gql`
  fragment lineItemFragment on LineItemType {
    id
    name
    sku
    batchNumber
    quantity
    totalVolume
    originalVolume
    expiryDate
    bottleNumber
    cost
    purchaseDate
    supplierName
    volumeUnits
  }
`;

export const stockItemFragment = gql`
  fragment stockItemFragment on StockItemListType {
    id
    name
    totalQuantity
    totalVolume
    species {
      id
      name
    }
    manufacturer
    manufacturerName
    applicationMethod
    activeIngredient
    withdrawal {
      id
      animalType {
        id
        name
        slug
      }
      withdrawalPeriodDays
      withdrawalType
    }
    lineItems {
      ...lineItemFragment
    }
  }
  ${lineItemFragment}
`;
